import { takeLatest, put } from "redux-saga/effects";
import { ApiCall } from "../api";
import {
  VLO_GETPOOL_START,
  VLO_GETPOOL_COMPLETE,
  VLO_CARGANDO_COMPLETE,
  VLO_GETMOVILES_START,
  VLO_GETMOVILES_COMPLETE,
  VLO_GETPROPERTIES_START,
  VLO_GETPROPERTIES_COMPLETE,
  VLO_SETMOVIL_COMPLETE,
  VLO_GETOPCIONES_COMPLETE,
  VLO_SETMIMOVIL_START,
  VLO_SETCENSO_START,
  NSB_MENSAJE_ADD,
} from "../../const/actionTypes";

export function* ObtenerPoolVehiculos({ payload }) {
  try {
    yield put({ type: VLO_CARGANDO_COMPLETE, payload: true });

    const json = yield ApiCall(
      "/api/Vehiculo/ObtenerVehiculos",
      "POST",
      JSON.stringify(payload),
      payload.token,
    );
    if (Boolean(json) && Boolean(json.Results)) {
      yield put({ type: VLO_GETPOOL_COMPLETE, payload: json.Results });
    }
  } catch (error) {
  } finally {
    yield put({ type: VLO_CARGANDO_COMPLETE, payload: false });
  }
}
export function* ObtenerVehiculos({ payload }) {
  try {
    yield put({ type: VLO_CARGANDO_COMPLETE, payload: true });

    const json = yield ApiCall(
      "/api/Vehiculo/ObtenerVehiculosPropios",
      "POST",
      JSON.stringify(payload),
      payload.token,
    );
    if (Boolean(json) && Boolean(json.Results)) {
      yield put({ type: VLO_GETMOVILES_COMPLETE, payload: json.Results });
    }
  } catch (error) {
  } finally {
    yield put({ type: VLO_CARGANDO_COMPLETE, payload: false });
  }
}
export function* ObtenerPropiedades({ payload }) {
  try {
    yield put({ type: VLO_CARGANDO_COMPLETE, payload: true });
    const p = { ...payload };
    yield put({ type: VLO_SETMOVIL_COMPLETE, payload: p.movil });
    const json = yield ApiCall(
      "/api/Vehiculo/ObtenerPropiedades",
      "POST",
      JSON.stringify(p),
      p.token,
    );
    if (Boolean(json) && Boolean(json.Results)) {
      yield put({ type: VLO_GETPROPERTIES_COMPLETE, payload: json.Results });
    }

    const json2 = yield ApiCall(
      "/api/Vehiculo/ObtenerOpciones",
      "POST",
      {},
      p.token,
    );
    if (Boolean(json2) && Boolean(json2.Results)) {
      yield put({ type: VLO_GETOPCIONES_COMPLETE, payload: json2.Results });
    }
  } catch (error) {
  } finally {
    yield put({ type: VLO_CARGANDO_COMPLETE, payload: false });
  }
}
export function* SetMiMovil({ payload }) {
  try {
    yield put({ type: VLO_CARGANDO_COMPLETE, payload: true });
    const p = { ...payload };
    const res = yield ApiCall(
      "/api/Vehiculo/SetVehiculoPropio",
      "POST",
      JSON.stringify(p),
      p.token,
    );
    if (res && !res.Error) {
      const json = yield ApiCall(
        "/api/Vehiculo/ObtenerVehiculosPropios",
        "POST",
        JSON.stringify(p),
        p.token,
      );
      if (Boolean(json) && Boolean(json.Results)) {
        yield put({ type: VLO_GETMOVILES_COMPLETE, payload: json.Results });
      }
    } else {
      const mensaje = {
        mensaje:
          "Hubo un error al guardar el vehículo.\nIntente nuevamente mas tarde.",
        variant: "error",
      };

      yield put({ type: NSB_MENSAJE_ADD, payload: mensaje });
    }
  } catch (error) {
  } finally {
    yield put({ type: VLO_CARGANDO_COMPLETE, payload: false });
  }
}
export function* SetCenso({ payload }) {
  try {
    yield put({ type: VLO_CARGANDO_COMPLETE, payload: true });
    const p = { ...payload };
    const res = yield ApiCall(
      "/api/Vehiculo/SetCensoVehiculo",
      "POST",
      JSON.stringify(p),
      p.token,
    );

    let mensaje;
    if (res && !res.Error) {
      mensaje = {
        mensaje: "Censo enviado con éxito.",
        variant: "success",
      };
      yield put({ type: VLO_SETMOVIL_COMPLETE, payload: null });
    } else {
      mensaje = {
        mensaje:
          "Hubo un error al enviar el censo.\nIntente nuevamente mas tarde.",
        variant: "error",
      };
    }
    yield put({ type: NSB_MENSAJE_ADD, payload: mensaje });
  } catch (error) {
    console.debug(error);
  } finally {
    yield put({ type: VLO_CARGANDO_COMPLETE, payload: false });
  }
}

export default function* vehiculo() {
  yield takeLatest(VLO_GETPOOL_START, ObtenerPoolVehiculos);
  yield takeLatest(VLO_GETMOVILES_START, ObtenerVehiculos);
  yield takeLatest(VLO_GETPROPERTIES_START, ObtenerPropiedades);
  yield takeLatest(VLO_SETMIMOVIL_START, SetMiMovil);
  yield takeLatest(VLO_SETCENSO_START, SetCenso);
}
